<!-- start banner Area -->
<section class="top-banner mb-4">
  <div class="top-banner-img" style="">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 style="padding: 30px 0px 0px 0px !important;">Candidats au poste de : <br>
            <span style="font-size: 22px">{{ job.getLibelle() }}</span>
          </h1>
          <p class="text-white link-nav"><a routerLink="/admin/offres-emploi/0" style="color: #ff5a00 !important">Offres
              d'emploi</a> <span class="lnr lnr-arrow-right"></span>
            <span> Candidatures</span>
          </p>

        </div>
      </div>
    </div>
  </div>
</section>
<!-- End banner Area -->

<!-- Start post Area -->
<section class="post-area section-gap">
  <div class="container">
    <!-- Loading -->
    <div class="row d-flex justify-content-center mb-4" *ngIf="isLoading">
      <span style="color: red">Chargement...</span>
    </div>

    <div class="row justify-content-center d-flex" style="width: 100%; overflow: auto;">
      <div class="col-lg-12 post-list">
        <table id="candidates" class="table table-striped table-bordered" style="width:100%">
          <thead>
            <tr>
              <th>Taux d'éligibilité</th>
              <th>Nom & prénom</th>
              <th>Sexe</th>
              <th>Age</th>
              <th>Email</th>
              <th>Téléphone</th>
              <!-- <th>Profession</th> -->
              <!-- <th>Années d'exp.</th>
              <th>Niveau de poste</th> -->
              <th>Dossier</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let candidates of candidatesJobsApply">
              <td>{{ candidates.getEligibilityRate() }} %</td>
              <td>{{ candidates.getCandidates().getFirstName() }} {{ candidates.getCandidates().getLastName() }}</td>
              <td>{{ candidates.getCandidates().getGender() }}</td>
              <td>{{ calculateAge(candidates.getCandidates().getDateBirth()) }} ans</td>
              <td>{{ candidates.getCandidates().getEmail() }}</td>
              <td>{{ candidates.getCandidates().getPhone1() }} / {{ candidates.getCandidates().getPhone2() }}</td>
              <!-- <td>{{ candidates.getCandidates().getCandidatesProfiles().getProfessions().getLibelle() }}</td>
              <td>{{ candidates.getCandidates().getCandidatesProfiles().getYearsOfExperience() }}</td>
              <td>{{ candidates.getCandidates().getCandidatesProfiles().getPositionLevel() }}</td> -->
              <td><button class="btn btn-info"
                  (click)="getDetailsCandidateApply(candidates.getCandidates().getId())">Voir</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>
<!-- End post Area -->